/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ClockIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "clock", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 8V12.5L15.5 15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ClockIcon);
export default ForwardRef;
//# sourceMappingURL=clockIcon.js.map